module.exports = __webpack_public_path__ + "img/13.c256ba6f.jpg";